<template>
  <div
    :class="classCard"
    height="270"
    width="238"
    v-on="$listeners"
    v-bind="[$attrs, $props]"
  >
    <div
      class="white--text insurance-company-card__best-price body mt-2 mt-xl-0 pl-xl-4 pl-2 py-2"
      v-if="item.melhor_cotacao && !item.foi_declinado"
    >
      Melhor Cotação
    </div>
    <v-row
      :class="
        'px-1 pb-6 text-center insurance-company-card__content--wrapper ' +
          paddingDisabledEdit
      "
    >
      <v-col cols="auto" class="pr-lg-3" v-if="showClientCheckbox">
        <v-checkbox
          v-model="item.exibir_cliente"
          label="Card exibido para o cliente"
          hide-details
          class="insurance-company-card__label-checkbox"
          @click="submitCheckUser"
        ></v-checkbox>
      </v-col>
      <v-spacer />
      <v-col cols="auto" class="pr-3" v-if="showTooltipCard">
        <v-tooltip bottom content-class="tooltip-label-form">
          <template v-slot:activator="{ on }">
            <v-icon color="secondary" size="15" v-on="on">
              fa-info-circle
            </v-icon>
          </template>
          <v-row>
            <v-col cols="12" class="px-4 py-3">
              <p class="white--text tooltip-label-text mb-0">
                Conforme previsto pela SUSEP os prazos das cotações tem vigência
                máxima de 15 dias. Após esse período as seguradoras se reservam
                no direito de retirar e/ou revisar as condições propostas nas
                minutas
              </p>
            </v-col>
          </v-row>
        </v-tooltip>
      </v-col>
      <v-col cols="auto" class="pr-3" v-if="showEditOption">
        <v-tooltip bottom content-class="tooltip-label-form">
          <template v-slot:activator="{ on }">
            <BaseButton icon @click="editMode" v-on="on">
              <v-icon size="17" color="primary"> fas fa-pencil-alt </v-icon>
            </BaseButton>
          </template>
          <v-row>
            <v-col cols="12" class="px-4 py-3">
              <p class="white--text tooltip-label-text mb-0">
                Inserir ou alterar cotação
              </p>
            </v-col>
          </v-row>
        </v-tooltip>
      </v-col>
      <v-col cols="12" class="pb-2">
        <v-avatar class="insurance-company-card__img" size="81">
          <img v-if="item.seguradora.logo" :src="item.seguradora.logo.url" />
        </v-avatar>
      </v-col>
      <v-col cols="12">
        <p class="mb-2 lightestGray--text insurance-company-card__name">
          {{ item.seguradora.nome }}
        </p>
      </v-col>
      <v-col cols="10" v-if="isEdit" class="pl-5">
        <BaseMoney
          id-element="valueFinancialData"
          placeholder="Inserir Valor"
          v-model="form.valor_premio"
        />
      </v-col>
      <v-col cols="12" v-else>
        <p class="primary--text mb-0 d-inline-block">
          R$
        </p>
        <p
          class="insurance-company-card__money mb-0 primary--text d-inline-block"
        >
          {{ asMoneyString(item.valor).replace("R$", "") }}
        </p>
      </v-col>
      <v-col cols="12" class="text-left pl-6">
        <span
          :class="
            'mb-0 insurance-company-card__text primary--text d-inline-block ' +
              paddingEdit
          "
        >
          <v-icon class="pr-1" color="primary" size="14">
            fa-file
          </v-icon>
          Minuta:
        </span>
        <v-tooltip
          bottom
          content-class="tooltip-label-form"
          v-if="showDraftContract"
        >
          <template v-slot:activator="{ on }">
            <a
              :href="draftContractName"
              download
              @click.prevent="onPreviewFile(draftContractAccordingStatus)"
              class="secondary--text pl-3"
              v-on="on"
            >
              minuta.pdf
            </a>
          </template>
          <v-row>
            <v-col cols="12" class="px-4 py-3">
              <p class="white--text tooltip-label-text mb-0">
                Faça o download do arquivo anexo da minuta
              </p>
            </v-col>
          </v-row>
        </v-tooltip>
        <span
          v-if="!isDraftContract && !isEdit"
          :class="
            'insurance-company-card__text primary--text d-inline-block ' +
              paddingEmission
          "
        >
          {{ emissionDraft }}
        </span>
        <div v-if="isEdit && isDraftContractBackup" class="d-inline">
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <BaseButton icon class="ml-1" v-on="on">
                <v-icon
                  size="17"
                  color="primary"
                  @click="openModalNewDraft('old')"
                >
                  far fa-edit
                </v-icon>
              </BaseButton>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Editar minuta
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
        </div>
        <div v-if="isEdit && isDraftContractBackup" class="d-inline">
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <BaseButton icon class="ml-1" v-on="on">
                <v-icon size="17" color="primary" @click="deleteDraftContract">
                  fa-times
                </v-icon>
              </BaseButton>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Remover minuta
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
        </div>
        <div v-if="isEdit" class="d-inline">
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <BaseButton icon class="ml-1" v-on="on">
                <v-icon
                  size="17"
                  color="primary"
                  @click="openModalNewDraft('new')"
                >
                  fa-upload
                </v-icon>
              </BaseButton>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Inserir minuta
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
        </div>
      </v-col>
      <v-col cols="12" class="text-left px-6" v-if="showCommissionValue">
        <v-icon color="primary" class="pr-1" size="14">
          fa-calculator
        </v-icon>
        <span
          class="mb-0 px-1 insurance-company-card__text primary--text d-inline-block pr-8"
        >
          Comissão:
        </span>
        <money
          :class="classInputPercentage"
          v-model="form.taxa_premio"
          v-bind="typePercentage"
          :disabled="!isEdit"
        />
      </v-col>
      <v-col cols="12" class="text-left pl-6" v-if="!isEdit">
        <img
          src="@/assets/ic_money.svg"
          class="insurance-company-card__img-money"
        />
        <span
          class="mb-0 px-1 insurance-company-card__text primary--text d-inline-block"
        >
          Limite disponível:
        </span>
        <p
          class="mb-0 insurance-company-card__text primary--text d-inline-block"
        >
          {{ asMoneyString(item.limite) }}
        </p>
      </v-col>
      <v-col cols="12" v-else class="my-3">
        <BaseButton
          v-html="'CANCELAR'"
          outlined
          color="pink"
          class="mr-2 px-2"
          @click="cancelEdit"
        />
        <BaseButton
          v-if="!item.foi_declinado"
          v-html="'DECLINAR'"
          @click="submitDecline"
          class="pink white--text mr-2 px-2"
        />
        <BaseButton
          v-html="'SALVAR'"
          @click="submitDraftContract"
          :class="classSaveButton"
        />
        <BaseButton
          v-if="item.foi_declinado"
          v-html="'REATIVAR'"
          @click="submitReactivateCost"
          class="secondary px-2"
        />
      </v-col>
      <v-col cols="12" class="pa-3 align-self-end">
        <v-divider />
      </v-col>
      <v-col cols="12" class="align-self-end">
        <v-row class="ma-0 justify-center align-center flex-nowrap">
          <v-col cols="auto">
            <v-icon
              size="18"
              :color="colorIcon"
              :class="{
                'yellow-icon-background': isAguardandoEmissaoMinuta
              }"
            >
              {{ iconAccordingStatus }}
            </v-icon>
          </v-col>
          <v-col
            cols="auto"
            class="insurance-company-card__footer-text-wrapper"
          >
            <span
              class="d-inline-block mb-0 pl-1 insurance-company-card__text primary--text"
            >
              {{ textAccordingStatus }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { asMoneyString, formatIsoDateToDDMMYYYYHHMM } from "@/utils/formats.js";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import _ from "lodash";
import { mapActions } from "vuex";
const ICON_STATUS = {
  simulada: "fas fa-exclamation-triangle",
  aguardando_cotacao: "fas fa-exclamation-triangle",
  aguardando_emissao_minuta: "fas fa-history",
  aguardando_analise_minuta: "fas fa-history",
};
const MOCK_DRAFT_CONTRACT = {
  valor: null,
  arquivo: null
};
export default {
  data: () => ({
    asMoneyString,
    isEdit: false,
    form: {
      valor_premio: null,
      taxa_premio: null,
      minuta: {
        valor: null,
        arquivo: null
      }
    },
    typePercentage: {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: " %",
      precision: 2,
      masked: false /* doesn't work with directive */
    }
  }),
  mixins: [DocumentsMixin],
  created() {
    this.updateForm();
  },
  computed: {
    classSaveButton() {
      let defaultClass = "secondary px-2";
      return this.item.foi_declinado
        ? `${defaultClass} mr-2`
        : `${defaultClass} mt-md-2 mt-lg-0`;
    },
    classCard() {
      return {
        "insurance-company-card__content-disabled": this.item.foi_declinado,
        "insurance-company-card__content": !this.item.foi_declinado,
        "insurance-company-card__yellow-border": this.isAguardandoEmissaoMinuta,
        "insurance-company-card__green-border": this.isCostSelectedByClient
      };
    },
    iconAccordingStatus() {
      // Colocar regra para validar se uma simulação ou não
      return ICON_STATUS[this.item.status.id] || "fa-check-circle";
    },
    textAccordingStatus() {
      // Colocar regra para validar conforme o status, qual
      // texto colocar no footer do card
      let prizeWithoutDraft = this.item.foi_declinado
        ? `Declinado em ${formatIsoDateToDDMMYYYYHHMM(
            this.item.data_ultima_atualizacao
          )} `
        : this.item.minuta?.arquivo
        ? `Atualizado em ${formatIsoDateToDDMMYYYYHHMM(
            this.item.data_ultima_atualizacao
          )} `
        : this.item.premio_informado_sem_minuta
        ? `Prêmio informado sem minuta.\n Atualizado em ${formatIsoDateToDDMMYYYYHHMM(
            this.item.data_ultima_atualizacao
          )} `
        : "Informações estimadas. Podem ser alteradas após emissão da minuta pela seguradora.";
      let isDraftContract =
        this.item.minuta?.arquivo && !this.item.foi_declinado
          ? `\n${this.emissionPolicy}!`
          : "";
      return this.statusText[this.item.status.id]
        ? this.statusText[this.item.status.id] + isDraftContract
        : `${prizeWithoutDraft} ${isDraftContract}`;
    },
    statusText() {
      return {
        simulada:
          "Informações estimadas. Podem ser alteradas após emissão da seguradora.",
        aguardando_cotacao:
          "Informações estimadas. Podem ser alteradas após emissão da minuta pela seguradora.",
        aguardando_emissao_minuta: 
          `Aguardando emissão da minuta pela seguradora.\nSolicitado em ${formatIsoDateToDDMMYYYYHHMM(this.item.data_ultima_atualizacao)}`,
        aguardando_analise_minuta:
          `Aguardando análise da minuta pelo solicitante.\nSolicitado em ${formatIsoDateToDDMMYYYYHHMM(this.item.data_ultima_atualizacao)}`
      };
    },
    isDraftContract() {
      return this.item.minuta?.arquivo;
    },
    draftContractName() {
      return this.item.minuta?.arquivo?.nome;
    },
    showEditOption() {
      return (
        !this.isClientUser &&
        !this.isEdit &&
        !this.disabledEdit &&
        !this.editing
      );
    },
    showCommissionValue() {
      return this.quotation.opcoes?.exibir_comissao;
    },
    showClientCheckbox() {
      return (
        !this.disabledEdit &&
        this.item.acoes.pode_exibir_cliente &&
        (!this.editing ||
          this.editing?.seguradora?.id == this.item.seguradora.id)
      );
    },
    isAguardandoEmissaoMinuta() {
      return (
        this.item.status.id === "aguardando_emissao_minuta" &&
        !this.item.selecionado_pelo_usuario
      );
    },
    isCostSelectedByClient() {
      return this.item.selecionado_pelo_usuario && !this.item.foi_declinado;
    },
    emissionDraft() {
      return this.item?.emissao_minuta_em_dias > 1
        ? `Emissão em ${this.item?.emissao_minuta_em_dias} dias`
        : this.item?.emissao_minuta_em_dias == 1
        ? `Emissão em ${this.item?.emissao_minuta_em_dias} dia`
        : "Emissão imediata";
    },
    emissionPolicy() {
      return this.item?.emissao_apolice_em_dias > 1
        ? `Emissão em ${this.item?.emissao_apolice_em_dias} dias`
        : this.item?.emissao_apolice_em_dias == 1
        ? `Emissão em ${this.item?.emissao_apolice_em_dias} dia`
        : "Emissão imediata";
    },
    paddingEmission() {
      return this.item?.emissao_minuta_em_dias > 9 ? "pl-0" : "pl-4";
    },
    colorIcon() {
      return this.item.minuta?.arquivo && this.item.via_api
        ? "success"
        : "primary";
    },
    showTooltipCard() {
      return (
        (this.isClientUser || this.disabledEdit) && this.item.minuta?.arquivo
      );
    },
    disabledAllOptions() {
      return (
        !this.showClientCheckbox &&
        !this.showTooltipCard &&
        !this.showEditOption
      );
    },
    paddingDisabledEdit() {
      return this.disabledEdit || this.disabledAllOptions ? "pt-10" : "pt-3";
    },
    textTooltipButtonDraftContract() {
      return this.item.minuta?.arquivo ? "Editar minuta" : "Inserir minuta";
    },
    paddingEdit() {
      return this.isEdit && (this.isDraftContract || this.isDraftContractBackup)
        ? "pr-1"
        : "pr-12";
    },
    isDraftContractBackup() {
      return this.updatedForm?.minuta?.arquivo || this.updatedForm?.arquivo;
    },
    showDraftContract() {
      return (
        (this.isDraftContract && !this.isEdit) ||
        (this.isDraftContractBackup && this.isEdit)
      );
    },
    draftContractAccordingStatus() {
      return this.isEdit ? this.isDraftContractBackup : this.isDraftContract;
    },
    classInputPercentage() {
      return this.isEdit
        ? "d-inline-block insurance-company-card__input"
        : "d-inline-block insurance-company-card__text primary--text insurance-company-card__text-input";
    }
  },
  methods: {
    ...mapActions(["showAlertNotification"]),
    showModal(item) {
      this.$emit("modal", item);
    },
    editMode() {
      this.isEdit = !this.isEdit;
      this.$emit("edit", this.item, this.form);
    },
    updateForm() {
      this.form.valor_premio = _.cloneDeep(this.item.valor);
      this.form.taxa_premio = _.cloneDeep(this.item.taxa);
      if (this.item.minuta) {
        this.form.minuta = _.cloneDeep(this.item.minuta);
      } else {
        this.form.minuta.valor = _.cloneDeep(this.item.valor);
      }
    },
    cancelEdit() {
      this.editMode();
      this.updateForm();
      this.$emit("edit", null);
    },
    validate() {
      let validation =
        this.form.taxa_premio && this.form.taxa_premio > 100 ? false : true;
      if (!validation) {
        this.showAlertNotification({
          message: "Comissão deve ser menor que 100%.",
          type: "error"
        });
      }
      return validation;
    },
    submitDraftContract() {
      if (!this.validate()) return;
      this.$emit("submit", this.getPayloadDraftContract());
    },
    getPayloadDraftContract() {
      let minuta = this.updatedForm?.minuta?.arquivo
        ? _.cloneDeep(this.updatedForm?.minuta)
        : this.updatedForm?.arquivo
        ? _.cloneDeep(this.updatedForm)
        : null;
      if (minuta) {
        minuta.valor = this.form.valor_premio;
        minuta.inicio_vigencia =
          minuta.inicio_vigencia || this.item.inicio_vigencia;
        minuta.fim_vigencia = minuta.fim_vigencia || this.item.fim_vigencia;
      }
      return {
        payload: {
          valor_premio: _.cloneDeep(this.form.valor_premio),
          taxa_premio: _.cloneDeep(this.form.taxa_premio),
          minuta: minuta,
          alteracao_valor_premio:
            minuta?.arquivo &&
            this.item.minuta?.arquivo?.url == minuta?.arquivo?.url
              ? this.item.valor != this.form.valor_premio ||
                this.item.taxa != this.form.taxa_premio
              : false
        },
        seguradora: this.item.seguradora.id,
        cotacao: this.$route.params.id
      };
    },
    submitReactivateCost() {
      if (!this.validate()) return;
      this.$emit("reactivate", this.getPayloadDraftContract());
    },
    submitCheckUser() {
      let payload = {
        payload: { exibir_cliente: this.item.exibir_cliente, minuta: null },
        seguradora: this.item.seguradora.id,
        cotacao: this.$route.params.id
      };
      this.$emit("submit", payload, true);
    },
    submitDecline() {
      this.$emit("decline", this.getPayloadDraftContract());
    },
    openModalNewDraft(type) {
      let payload =
        type == "new"
          ? _.cloneDeep(MOCK_DRAFT_CONTRACT)
          : this.updatedForm?.minuta || this.updatedForm || this.item.minuta;
      this.$emit("draftForm", payload);
    },
    deleteDraftContract() {
      this.$emit("remove", this.item);
    }
  },
  props: {
    item: {
      type: Object
    },
    disabledEdit: {
      type: Boolean
    },
    isClientUser: {
      type: Boolean
    },
    editing: {
      type: Object
    },
    updatedForm: {
      type: Object
    },
    quotation: {
      type: Object
    },
    costUpdatedToggle: {
      type: Object
    }
  },
  watch: {
    costUpdatedToggle: {
      deep: true,
      handler(value) {
        value.insuranceCompanyId === this.item.seguradora.id &&
          this.cancelEdit();
      }
    }
  }
};
</script>
<style lang="sass">
.insurance-company-card__
  &content
    border: 1px solid #D5D5E0 !important
    border-radius: 4px
    background-color: #FFFFFF
    cursor: pointer
    overflow: hidden
    position: relative
    &--wrapper
      height: 100%
  &content-blocked
    border: 3px dashed #D5D5E0 !important
    border-radius: 4px
    background-color: #F0F0F7
    cursor: default
  &content-disabled
    border: 1px solid red !important
    border-radius: 4px
    background-color: #F0F0F7
  &yellow-border
    border: 3px dashed #FFEEB9 !important
  &green-border
    border: 3px solid #49DCBB !important
  &name
    font-size: 14px
    font-weight: 600
  &money
    font-size: 24px
    font-weight: 800
  &text
    font-size: 12px
    font-weight: 700
    white-space: pre-wrap
  &active-blue
    border: 2px solid #059EE4 !important
    box-shadow: 0 12px 47px 0 rgba(44,48,64,0.2) !important
    p:nth-child(1)
      color: #059EE4 !important
    p:nth-child(2)
      color: #059EE4 !important
    .v-avatar
      border: 1px solid #059EE4 !important
  &active-green
    border: 3px solid #49DCBB !important
    box-shadow: 0 12px 47px 0 rgba(44,48,64,0.2) !important
    p:nth-child(1)
      color: #49DCBB !important
    p:nth-child(2)
      color: #49DCBB !important
    .v-avatar
      border: 1px solid #49DCBB !important
  &img
    border: 1px solid #D5D5E0
    background-color: #FFFFFF
    img
      object-fit: cover
  &img-money
    vertical-align: middle
  &button-add
    width: 24px !important
    min-width: 24px !important
  &label-checkbox
    margin-top: 0
    padding-left: 10px
    label
      font-size: 12px
  &input
    width: 80px
    border: 1px solid #D5D5E0 !important
    border-radius: 4px
    background-color: #FFFFFF
  &footer-text-wrapper
    max-width: 90%
  &best-price
    transform: skewY(-30deg)
    background: #9bbb59
    position: absolute
    width: 70%
  &text-input
    width: 80px
.yellow-icon-background
  z-index: 1 !important
  &:after
    background-color: #FFEEB9 !important
    opacity: 1 !important
    border-radius: 50%
    z-index: -1 !important
</style>
